import { apiClient, textControlAPIClient } from "api";
import {
  TCurrentJobDetail,
  TDocumentResponse,
  THistoryDetail,
  TJob,
  TJobDetails,
  TJobFilter,
  TTextControlJobDetails,
  TVoiceFile
} from "./models/types";

const API_URL = "/Job";

export const getJobs = async (jobFilter: TJobFilter, accountId: string): Promise<TJob[]> => {
  const response = await apiClient.post<TJob[]>(`${API_URL}/${accountId}/jobs`, jobFilter);
  return response.data;
};

export const getJobDetails = async (jobId: number, accountId: string): Promise<TJobDetails> => {
  const response = await apiClient.get<TJobDetails>(`${API_URL}/${accountId}/jobs/${jobId}`);
  return response.data;
};

export const loadVoiceFiles = async (
  jobId: number,
  accountId: string
): Promise<TVoiceFile[]> => {
  const response = await apiClient.get<TVoiceFile[]>(
    `${API_URL}/${accountId}/${jobId}/voice-files`
  );
  return response.data;
};

export const loadDocument = async (jobDetails: TTextControlJobDetails): Promise<void> => {
  const response = await textControlAPIClient.post<void>(`/Document/load`, jobDetails);
  return response.data;
};

export const saveDocument = async (jobDetails: TTextControlJobDetails): Promise<void> => {
  const response = await textControlAPIClient.post<void>(`/Document/save`, jobDetails);
  return response.data;
};

export const getPDFDocument = async (
  jobDetails: TTextControlJobDetails
): Promise<TDocumentResponse> => {
  const response = await textControlAPIClient.post<Blob>(`/Document/get-pdf-file`, jobDetails, {
    responseType: "blob",
    timeout: 300000
  });

  const contentDisposition = response.headers["content-disposition"];
  let filename = "document.txt";

  if (contentDisposition) {
    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
    }
  }

  if (filename == `document.txt`) {
    throw new Error("file could not be fetched");
  }

  return {
    blob: response.data,
    filename,
    contentLength: Number(response.headers["content-length"] ?? 0)
  };
};

export const getPDF2Document = async (
  jobDetails: TTextControlJobDetails
): Promise<TDocumentResponse> => {
  const response = await textControlAPIClient.post<Blob>(
    `/Document/get-pdf2-file`,
    jobDetails,
    {
      responseType: "blob",
      timeout: 300000
    }
  );

  const contentDisposition = response.headers["content-disposition"];
  let filename = "document.txt";

  if (contentDisposition) {
    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
    }
  }

  if (filename == `document.txt`) {
    throw new Error("file could not be fetched");
  }

  return {
    blob: response.data,
    filename,
    contentLength: Number(response.headers["content-length"] ?? 0)
  };
};

export const getDocument = async (
  jobDetails: TTextControlJobDetails
): Promise<TDocumentResponse> => {
  const response = await textControlAPIClient.post<Blob>(
    `/Document/get-document-file`,
    jobDetails,
    { responseType: "blob", timeout: 300000 }
  );

  const contentDisposition = response.headers["content-disposition"];
  console.log(response.headers);
  let filename = "document.txt";

  if (contentDisposition) {
    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
    }
  }

  if (filename == `document.txt`) {
    throw new Error("file could not be fetched");
  }

  return {
    blob: response.data,
    filename,
    contentLength: Number(response.headers["content-length"] ?? 0)
  };
};

export const updatePrintDownloadStatus = async (
  jobIds: string[],
  accountId: string
): Promise<void> => {
  if (!jobIds || jobIds.length === 0) {
    throw new Error("No job IDs provided.");
  }
  await apiClient.post<void>(`${API_URL}/${accountId}/print-download-status`, jobIds);
};

export const lockJob = async (jobId: number, accountId: string): Promise<string> => {
  const response = await apiClient.post<string>(`${API_URL}/${accountId}/jobs/${jobId}/lock`);
  return response.data;
};

export const loadJobHistory = async (
  jobId: number,
  accountId: string
): Promise<THistoryDetail[]> => {
  const response = await apiClient.get<THistoryDetail[]>(
    `${API_URL}/${accountId}/jobs/${jobId}/history`
  );
  return response.data;
};

export const loadJobCurrent = async (
  jobId: number,
  accountId: string
): Promise<TCurrentJobDetail> => {
  const response = await apiClient.get<TCurrentJobDetail>(
    `${API_URL}/${accountId}/jobs/${jobId}/current-detail`
  );
  return response.data;
};

export const updateLockJob = async (
  jobId: number,
  sessionId: string,
  accountId: string
): Promise<number> => {
  const response = await apiClient.post<number>(
    `${API_URL}/${accountId}/jobs/${jobId}/lock-update/${sessionId}`
  );
  return response.data;
};

export const saveJob = async (
  jobId: number,
  sessionId: string,
  action: string,
  jobDetails: TJobDetails,
  accountId: string
): Promise<void> => {
  const response = await apiClient.post<void>(
    `${API_URL}/${accountId}/jobs/${jobId}/save?sessionId=${encodeURIComponent(
      sessionId
    )}&action=${encodeURIComponent(action)}`,
    jobDetails
  );
  return response.data;
};

export const updateJob = async (
  jobId: number,
  jobDetails: TJobDetails,
  accountId: string
): Promise<void> => {
  console.log(jobId);
  const response = await apiClient.post<void>(
    `${API_URL}/${accountId}/jobs/${jobId}`,
    jobDetails
  );
  return response.data;
};
